package com.anjuros.website.redesign.sections.trades

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdRichText
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.styles.RdIconBadgeStyle
import com.anjuros.website.redesign.styles.RdSectionFlushTopStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.styles.TradesNeedStyle
import com.anjuros.website.redesign.styles.TradesNeedsGridStyle
import com.anjuros.website.redesign.util.RdIcons
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** What every trade website needs; the main body text for search engines on this page. */
@Composable
fun TradesNeedsSection() {
    RdSection(
        id = "needs",
        labelledBy = "needs-h",
        modifier = RdSectionStyle.toModifier().then(RdSectionFlushTopStyle.toModifier()),
    ) {
        RdSectionHead(RdText.TRADES_NEEDS_EYEBROW, "needs-h", RdText.TRADES_NEEDS_TITLE, RdText.TRADES_NEEDS_LEDE)
        Div(TradesNeedsGridStyle.toModifier().toAttrs()) {
            Need({ RdIcons.Search(size = 22) }, RdText.NEED1_TITLE) { Text(LocalText(RdText.NEED1_TEXT)) }
            Need({ RdIcons.Phone(size = 22) }, RdText.NEED2_TITLE) { Text(LocalText(RdText.NEED2_TEXT)) }
            Need({ RdIcons.Star(size = 22) }, RdText.NEED3_TITLE) { Text(LocalText(RdText.NEED3_TEXT)) }
            Need({ RdIcons.Mail(size = 22) }, RdText.NEED4_TITLE) { RdRichText(LocalText(RdText.NEED4_TEXT)) }
            Need({ RdIcons.Dashboard(size = 22) }, RdText.NEED5_TITLE) {
                Text(LocalText(RdText.NEED5_TEXT_START))
                RdLink(RdRoute.PORTAL) { Text(LocalText(RdText.NEED5_LINK)) }
                Text(LocalText(RdText.NEED5_TEXT_END))
            }
            Need({ RdIcons.Pencil(size = 22) }, RdText.NEED6_TITLE) { Text(LocalText(RdText.NEED6_TEXT)) }
        }
    }
}

@Composable
private fun Need(icon: @Composable () -> Unit, title: RdText, text: @Composable () -> Unit) {
    Div(TradesNeedStyle.toModifier().toAttrs()) {
        Span(RdIconBadgeStyle.toModifier().toAttrs()) { icon() }
        H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(title)) }
        P { text() }
    }
}
